/**
 * Creates hierarchical menu based on WordPress menu.
 * @link https://www.wpgraphql.com/docs/menus/#hierarchical-data
 */
import * as React from "react"
import UniversalLink from "§/src/utils/UniversalLink"

// Styles
import './_widget-menu.scss';

const WidgetMenu = ( props ) => {

  const menu = props.wpMenu.nodes;
  const id = props.id;
  const className = props.className;
  const menuTitle = props.menuTitle;

  return (

    <div id={ id } className={ 'widget-menu ' + className }>
      <span className="title fs-14 pb-3 pb-md-4">{ menuTitle }</span>
      <ul className="menu-bottom list-flat list-vert">
        { menu.map((menuItem, index) => (
          <li key={ menuItem.id }>
            <UniversalLink
              to={ menuItem.uri }
              activeClassName="active"
            >
              { menuItem.title }
            </UniversalLink>
          </li>
        )) }
      </ul>
    </div>

  )
}

export default WidgetMenu
